import { DisplayPosition } from '@/type/display-position';
// import {
//   CnCascaderSelect,
//   componentMap as formComponentMap,
// } from '@cainiaofe/cn-ui-m';
import { condition, handleSelectDataSource, handleSelectRequestConfig, } from '../../util/util';
import { getDataOriginSetterSnippet, getRequestConfigSetterSnippet, getStaticDataSourceSnippet, } from '../setter-snippet';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '级联选择器',
    componentName: 'CnCascaderSelect',
    // component: CnCascaderSelect,
    // formComponent: formComponentMap.CnCascaderSelect,
    getFormItemDefaultProps: () => {
        return {
            placeholder: '请选择',
        };
    },
    formItemBeforeHandler: (formItem, config) => {
        const { isDesign, urlParams, formValue, state } = config;
        handleSelectRequestConfig({
            componentProps: formItem?.['x-component-props'],
            isDesign,
            urlParamsDataSource: urlParams,
            recordDataSource: formValue,
            state,
        });
        handleSelectDataSource({
            componentProps: formItem?.['x-component-props'],
            state,
        });
    },
    getDefaultProps: () => {
        return {
            dataOrigin: 'static',
            dataSource: [
                {
                    label: '选项一',
                    value: '选项一',
                },
                {
                    label: '选项二',
                    value: '选项二',
                },
            ],
        };
    },
    getPrototypeList: (position) => {
        return [
            getDataOriginSetterSnippet({
                display: 'inline',
            }),
            getRequestConfigSetterSnippet({
                condition: (prop) => {
                    return (condition(prop, 'CnCascaderSelect', 'componentName') &&
                        prop?.parent?.getPropValue?.('dataOrigin') === 'request');
                },
            }, {
                position,
            }),
            {
                name: 'dataSource',
                title: '编辑静态数据',
                display: 'plain',
                tip: '编辑静态展示数据',
                className: 'cn-datasource-relative-setter',
                setter: getStaticDataSourceSnippet(),
                condition(prop) {
                    return (condition(prop, 'CnCascaderSelect', 'componentName') &&
                        prop?.parent?.getPropValue?.('dataOrigin') === 'static');
                },
            },
        ];
    },
};
